export const getRosters = state => {

    let mergedAwayRoster        = null;
    let mergedAwayTeamOfficials = null;
    let mergedHomeRoster        = null;
    let mergedHomeTeamOfficials = null;
    const activeGame            = state.items.games.activeItem;
    const rosters               = state.items.rosters && ( activeGame.id in state.items.rosters ) ? state.items.rosters[ activeGame.id ] : null;
    const localChanges          = ( activeGame.id in state.localChanges.rosters ) ? state.localChanges.rosters[ activeGame.id ] : null;

    if ( rosters && rosters.items ) {

        mergedAwayRoster        = mergeChanges( rosters.items.awayRoster,        localChanges       );
        mergedAwayTeamOfficials = mergeChanges( rosters.items.awayTeamOfficials, localChanges, true );
        mergedHomeRoster        = mergeChanges( rosters.items.homeRoster,        localChanges       );
        mergedHomeTeamOfficials = mergeChanges( rosters.items.homeTeamOfficials, localChanges, true );

    }

    return {
        mergedAwayRoster,
        mergedAwayTeamOfficials,
        mergedHomeRoster,
        mergedHomeTeamOfficials,
        rosters
    };

};

export const getScores = ( periodScores, scores ) => {

    if ( scores ) {

        scores.forEach( ( e, i ) => {

            periodScores[ i ] = { ...periodScores[ i ], score: e };

        } );

    }

    return periodScores;

};

const mergeChanges = ( items, localChanges, isTeamOfficial = false ) => {

    if ( ! items ) {

        return null;

    }

    const mergedItems = [];

    items.forEach( e => {

        let item = { ...e };

        if ( localChanges && ( item.id in localChanges ) && Object.entries( localChanges[ item.id ] ).length !== 0 ) {

            item = { ...item, ...localChanges[ item.id ], locallyChanged: true };

        } else {

            item.locallyChanged = false;

        }

        parseKey( item, 'lineupData'     );
        // parseKey( item, 'additionalData' );

        item = { ...item, ...item.lineupData, /* ...item.additionalData, */ isTeamOfficial };

        mergedItems.push( item );

    } );

    return mergedItems;

};

export const parseKey = ( item, key ) => {

    if ( ( key in item ) && typeof item[ key ] !== 'object' ) {

        try {

            item[ key ] = JSON.parse( item[ key ] );

        } catch ( e ) {

            item[ key ] = {};

        }

    }

};

export const reduceLoadingEligiblesFailed = ( action, state, lastUpdate, key ) => {

    const { teamId }             = action.payload;
    const newEligibles           = { ...state[ key ] };
    const items                  = ( teamId in newEligibles[ key ] ) ? newEligibles[ key ][ teamId ].items : null;
          newEligibles[ teamId ] = { items, lastUpdate };

    return { ...state, [ key ]: newEligibles };

};

export const reduceLoadingEligiblesSucceeded = ( action, state, lastUpdate, key ) => {

    const { teamId, eligibles }  = action.payload;
    const newEligibles           = { ...state[ key ] };
          newEligibles[ teamId ] = { items: eligibles, lastUpdate };

    return { ...state, [ key ]: newEligibles };


};